export default {
    statusHidden: 'hidden',
    statusCancelled: 'cancelled',
    productConditionAll: 'all',
    productCondition1OfAll: '1OfAll',
    productConditionAllOf1League: 'allOf1League',
    productCondition1Of1League: '1Of1League',
    productConditionAllOf1District: 'allOf1District',
    productCondition1Of1District: '1Of1District',
    productConditionAllCustom: 'allCustom',
    productCondition1OfAllCustom: '1OfAllCustom',
    productConditionLabel(productCondition) {
        switch(productCondition) {
            case this.productConditionAll:
                return Core.Definition.getDefinition('Toutes les dates');
                break
            case this.productCondition1OfAll:
                return Core.Definition.getDefinition('Une seule date parmi toutes les dates');
                break
            case this.productConditionAllOf1League:
                return Core.Definition.getDefinition('Toutes les dates d\'une seule ligue');
                break
            case this.productCondition1Of1League:
                return Core.Definition.getDefinition('Une seule date d\'une seule ligue');
                break
            case this.productConditionAllOf1District:
                return Core.Definition.getDefinition('Toutes les dates d\'une seule région');
                break
            case this.productCondition1Of1District:
                return Core.Definition.getDefinition('Une seule date d\'une seule région');
                break
            case this.productConditionAllCustom:
                return Core.Definition.getDefinition('Toutes les dates personnalisées');
                break
            case this.productCondition1OfAllCustom:
                return Core.Definition.getDefinition('Une seule date parmi toutes les dates personnalisées');
                break
        }
    },
    productConditionDescription(productCondition) {
        switch(productCondition) {
            case this.productConditionAll:
                return Core.Definition.getDefinition('Le participant pourra assiter à toutes les dates de la saison.')
                break
            case this.productCondition1OfAll:
                return Core.Definition.getDefinition('Le participant pourra choisir une seule date parmi toutes les dates de la saison.')
                break
            case this.productConditionAllOf1League:
                return Core.Definition.getDefinition('Le participant pourra participer à toutes les dates de la saison d\'une seule ligue. Si l\'option Ligue est laissé vide, le participant pourra choisir la ligue.')
                break
            case this.productCondition1Of1League:
                return Core.Definition.getDefinition('Le participant pourra choisir une seule date de la saison d\'une seule ligue. Si l\'option Ligue est laissé vide, le participant pourra choisir la ligue.')
                break
            case this.productConditionAllOf1District:
                return Core.Definition.getDefinition('Le participant pourra participer à toutes les dates de la saison d\'une seule région. Si l\'option région est laissé vide, le participant pourra choisir la région.')
                break
            case this.productCondition1Of1District:
                return Core.Definition.getDefinition('Le participant pourra choisir une seule date de la saison d\'une seule région. Si l\'option région est laissé vide, le participant pourra choisir la région.')
                break
            case this.productConditionAllCustom:
                return Core.Definition.getDefinition('Le participant pourra pariticiper à toutes les dates sélectionnées sous l\'onglet dates de la saison.')
                break
            case this.productCondition1OfAllCustom:
                return Core.Definition.getDefinition('Le participant pourra pariticiper à toutes les dates sélectionnées sous l\'onglet dates de la saison.')
                break
        }
    },
    productConditionOptions(keys) {
        if (keys === undefined) {
            keys = [this.productConditionAll, this.productCondition1OfAll, this.productConditionAllOf1League, this.productCondition1Of1League, this.productConditionAllOf1District, this.productCondition1Of1District, this.productConditionCustom]
        }
        let options = []
        for(let key in keys) {
            key = keys[key]
            options.push(
                {
                    value: key,
                    label: this.productConditionLabel(key),
                    description: this.productConditionDescription(key)
                }
            )
        }
        return options
    },
    displayImage(image) {
        if (image !== '' && image != null) {
            if (!Array.isArray(image)) {
                image = JSON.parse(image)
            }
            if (image[0] !== undefined && image[0].src !== undefined) {
                return image[0].src
            }
        }
        return Mantle.Config.api.url + Mantle.Config.defaultProductImgUrl
    }
}